const DOC = document;

const Elements = function(options){
	var els;
	var i = 0;
	var element = DOC;
	var elements = [];
	var hasAction = false;

	if (typeof options !== 'object' || options == null) {
		options = {};
	}

	if (!('selector' in options) || typeof options.selector !== 'string') {
		return null;
	}
	options.mode = 'mode' in options && ['className', 'id'].indexOf(options.mode) ? options.mode : 'className';
	hasAction = 'onElement' in options && typeof options.onElement === 'function';

	if ('element' in options && typeof options.element === 'object' && options.element !== null && 'nodeName' in options.element) {
		element = options.element;
	}
	if (options.mode === 'id') {
		els = DOC.getElementById(options.selector);

		if (typeof els !== 'object' || els === null || !('nodeName' in els)) {
			return null;
		}

		if (hasAction) {
			options.onElement(els);
		}
		return els;

	}
	els = element.getElementsByClassName(options.selector);

	if (els == null || typeof els !== 'object' || !('length' in els) || !els.length) {
		return null;
	}

	for (i; i < els.length; i++) {
		elements[elements.length] = els[i];

		if (hasAction) {
			options.onElement(els[i]);
		}

	}

	return elements;

};

export default Elements;